<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k6agR1/tc-custom/9780830899975.jpg?1696025502529" alt="This image is the cover for the book Modern Art and the Life of a Culture, Studies in Theology and the Arts Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Modern Art and the Life of a Culture, Studies in Theology and the Arts Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong> <em>Christianity Today</em> Book of the Year Award of Merit - Culture and the Arts</strong> </p> <p> <strong>For many Christians, engaging with modern art raises several questions: Is the Christian faith at odds with modern art?</strong> Does modernism contain religious themes? What is the place of Christian artists in the landscape of modern art?</p> <p>Nearly fifty years ago, Dutch art historian and theologian Hans Rookmaaker offered his answers to these questions when he published his groundbreaking work, <em>Modern Art and the Death of a Culture</em>, which was characterized by both misgivings and hopefulness.</p> <p>While appreciating Rookmaaker's invaluable contribution to the study of theology and the arts, this volume—coauthored by an artist and a theologian—responds to his work and offers its own answers to these questions by arguing that there were actually strong religious impulses that positively shaped modern visual art. Instead of affirming a pattern of decline and growing antipathy towards faith, the authors contend that theological engagement and inquiry can be perceived across a wide range of modern art—French, British, German, Dutch, Russian, and North American—and through particular works by artists such as Gauguin, Picasso, David Jones, Caspar David Friedrich, van Gogh, Kandinsky, Warhol, and many others.</p> <p>This Studies in Theology and the Arts volume brings together the disciplines of art history and theology and points to the signs of life in modern art in order to help Christians navigate these difficult waters.</p> <p>The Studies in Theology and the Arts  series encourages Christians to thoughtfully engage with the relationship between their faith and artistic expression, with contributions from both theologians and artists on a range of artistic media including visual art, music, poetry, literature, film, and more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan A. Anderson, William A. Dyrness
      </h2>
      
      <p class="authorDescription body article"><p>Jonathan A. Anderson (MFA, California State University, Long Beach) is an artist, art critic and associate professor of art at Biola University. He is the coauthor, along with Amos Yong, of <em>Renewing Christian Theology: Systematics for a Global Christianity</em> and a contributor to <em>Christian Scholarship in the Twenty-First Century: Prospects and Perils</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03674c77